import { FC } from 'react';
import { Button } from 'antd';

import css from '../CourseEnrollment.module.css';

interface Props {
  onBack: () => void;
  onNext?: () => void;
  nextLabel?: string;
  hideNext?: boolean;
  borderless?: boolean;
  loading?: boolean;
}

const StepFooter: FC<Props> = ({
  onBack,
  onNext,
  nextLabel = 'Далее',
  hideNext,
  borderless,
  loading,
}) => (
  <div
    className={css.Footer}
    style={borderless ? { borderTop: 'none', paddingTop: 0 } : undefined}
  >
    <Button className={css.BackBtn} onClick={onBack} disabled={loading}>
      Назад
    </Button>
    {!hideNext && (
      <Button type='primary' className={css.NextBtn} onClick={onNext} loading={loading} disabled={loading}>
        {nextLabel}
      </Button>
    )}
  </div>
);

export default StepFooter;
